import { render } from "./OvCloseModal.vue?vue&type=template&id=b027263c&scoped=true"
import script from "./OvCloseModal.vue?vue&type=script&lang=js"
export * from "./OvCloseModal.vue?vue&type=script&lang=js"

import "./OvCloseModal.vue?vue&type=style&index=0&id=b027263c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b027263c"]])

export default __exports__